module.exports = __webpack_public_path__ + "img/20200614_110937.61aeb4ac.jpg";